/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SPINNER from "./SPINNER";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

const Progress = (props) => {
  const current_number = new Intl.NumberFormat("id-ID", {
    style: "decimal",
  }).format(parseInt(props.current_number));

  const total_number = new Intl.NumberFormat("id-ID", {
    style: "decimal",
  }).format(parseInt(props.total_number));

  let percent = parseInt((props.current_number / props.total_number) * 100);

  if (percent > 100) {
    percent = 100;
  }

  return (
    <main>
      <div
        style={{
          height: "11px",
          backgroundColor: "#ffffff",
          border: "1px solid rgb(154, 154, 154)",
          borderRadius: "2rem",
          padding: "1px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${percent}%`,
            backgroundColor: props.color ? props.color : "#0ca5eb",
            borderRadius: "2rem",
            transition: "width 0.05s linear",
          }}
        />
      </div>
      {!props.is_hide_text && (
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td
                className="text_left text_inferior"
                style={{ height: "20px" }}
              >
                {props.name || "Proses"}

                {!props.is_hide_count && `(${current_number}/${total_number})`}

                {props.is_loading && (
                  <span className="margin_left">
                    <SPINNER
                      unik="ai_spinner"
                      width={8}
                      border={0.25}
                      color1="white"
                      color2={props.color ? props.color : "#0ca5eb"}
                    />
                  </span>
                )}
              </td>
              <td className="text_right text_medium">{percent}%</td>
            </tr>
          </tbody>
        </table>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(Progress);
